import { DonatePanel } from "@components/donate/DonatePanel"
import { tv } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { useAppData } from "eddev/hooks"

export const meta: BlockMeta = {
  title: "Donate Panel",
  category: "embeds",
  description: "A panel for accepting donations",
  keywords: ["donate", "donation"],
  tags: ["#subpage", "#homepage"],
  flags: {
    fullWidth: true,
    marginRule: "large-card",
  },
  blockStyles: [
    {
      label: "Medium",
      name: "medium",
      isDefault: true,
    },
    {
      label: "Large",
      name: "large",
    },
    {
      label: "Small",
      name: "small",
    },
  ],
}

export default defineBlock("tickets/donate-panel", (props) => {
  let donationHash = useAppData((data) => data.sffSettings?.donations?.ferveDonationsHash)

  if (props.ferveHash) {
    donationHash = props.ferveHash
  }

  const styles = createStyles({
    layout: props.blockStyle || "large",
  })

  return (
    <div>
      <div className={styles.base()}>
        <div className={styles.column()}>
          <DonatePanel
            title={<EditableText store="title" defaultValue="Support Sydney Film Festival" plainText />}
            description={<EditableText store="description" placeholder="Enter a description..." plainText />}
            label={<EditableText store="label" defaultValue="Select the amount you wish to donate:" plainText />}
            ferveHash={donationHash!}
            amounts={props.donationAmounts?.map((row) => row?.amount!)}
            altDonationLink={
              props.campaignLink?.url
                ? {
                    title: props.campaignLink.title!,
                    url: props.campaignLink.url!,
                    target: props.campaignLink.target!,
                  }
                : undefined
            }
            readMoreLink={
              props.readMoreLink?.url
                ? {
                    title: props.readMoreLink.title!,
                    url: props.readMoreLink.url!,
                    target: props.readMoreLink.target!,
                  }
                : undefined
            }
          />
        </div>
      </div>
    </div>
  )
})

const createStyles = tv({
  base: "grid-auto",
  slots: {
    column: "",
  },
  variants: {
    layout: {
      medium: {
        column: "col-span-12 lg:col-1-10",
      },
      large: {
        column: "col-span-12",
      },
      small: {
        column: "col-subpage-content-grid",
      },
    },
  },
})
